module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTcgMGMzLjg2IDAgNyAzLjE0IDcgNyAwIDMuODU5LTMuMTQgNy03IDdzLTctMy4xNDEtNy03YzAtMy44NiAzLjE0LTcgNy03em0uNjk4IDMuODQ5YS42OTkuNjk5IDAgMCAwLTEuMzk4IDB2My40OTNjMCAuNTg2LjY3Ny45MTIgMS4xMzUuNTQ3bDMuNTAyLTMuMjExYS42OTkuNjk5IDAgMSAwLS44NzItMS4wOTNMNy42OTggNS44OTFWMy44NDl6Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ../statics/assets/svg/clock.svg
// module id = 3457
// module chunks = 0